<p-button
  icon="pi pi-ellipsis-v"
  (click)="op.toggle($event)"
  severity="secondary"
  rounded
></p-button>
<p-popover #op>
  <div class="flex w-full flex-col gap-2">
    @for (option of options; track $index) {
      @if (!option.hidden) {
        <p-button
          [icon]="option.icon"
          [text]="true"
          severity="secondary"
          [label]="option.label"
          [attr.data-testid]="option.testId"
          (click)="option.action && option.action()"
          styleClass="!w-full !justify-start"
          [disabled]="option.disabled"
        />
      }
    }
  </div>
</p-popover>
